import { Block, IconButton, Typography } from '@xprog/prensa'
import Icon from 'components/Icon/Icon.index'
import { useIcon } from 'hooks/useIcon'
import React from 'react'

export const SideMenuServiceButton = ({ href, variant, target }) => {
  const renderIcon = () => {
    switch (variant) {
      case 'WhatsApp':
        return 'IcWhatsAppCinza'
      case 'JornalDigital':
      case 'tocantins':
        return 'IcVersaoDigitalCinza'
      default:
        return ''
    }
  }

  const renderName = () => {
    switch (variant) {
      case 'WhatsApp':
        return 'WhatsApp'
      case 'JornalDigital':
        return 'Jornal Digital'
      case 'tocantins':
        return 'Acervo'  
      default:
        return ''
    }
  }

  const icon = renderIcon()
  const name = renderName()
  const styles = {
    button: {
      borderRadius: '$alternative',
      backgroundColor: '#EAEAEA',
      height: '52px',
      width: '52px'
    }
  }

  const onClickProps = href ? {
    onClick: () => target === '_blank' ?
      window.open(href, "_blank") :
      window.location.assign(href)
  } : {}
  return (
    <Block
      css={{
        align: ['column', 'center', 'middle'],
        m: '$2'
      }}
      {...onClickProps}
    >
      <IconButton
        variant='ghost'
        css={styles}
        icon={<Icon {...useIcon(icon)} />}
      />
      <Typography
        css={{
          color: '#525252',
          fontFamily: '$primary',
          fontSize: '10px',
          fontWeight: 400
        }}
      >
        {name}
      </Typography>
    </Block>
  )
}